import * as Actions from "../constant/ActionTypes";
import * as api from '../../api';

export const fetchUser = (user) => async (dispatch) => {
    try {
        const { data } = await api.fetchUser({ user: user });
       
        dispatch({
            type: Actions.FETCH_USER,
            payload: data
        })
    } catch (error) {
        // console.log(error);
    }
}